<script lang="ts" setup>
import { ref, watch } from 'vue';

const props = withDefaults(defineProps<{
  state: 'success' | 'error';
  timeout?: number;
}>(), {
  timeout: 3000,
  state: 'error'
});

const message = defineModel<string>({ default: '', required: true });

const visible = ref(false);
const currentTimeout = ref<NodeJS.Timeout | null>(null);

const startTimeout = () => {
  currentTimeout.value = setTimeout(() => {
    visible.value = false;
    message.value = '';
  }, props.timeout);
};

const cancelTimeout = () => {
  if (currentTimeout.value) {
    clearTimeout(currentTimeout.value);
    currentTimeout.value = null;
  }
};

watch(() => message.value, (newMessage) => {
  if (newMessage === '') return;
  // if message is replaced by different one we restart the animation by toggling the visibility
  visible.value = false;
  visible.value = true;

  startTimeout();
});
</script>

<template>
  <Transition name="data-error">
    <div
      class="toast-wrapper"
      v-if="visible"
    >
      <div
        class="toast-content"
        :class="state"
        @mouseenter="cancelTimeout"
        @mouseleave="startTimeout"
      >
        <slot>{{ message }}</slot>
      </div>
    </div>
  </Transition>
</template>

<style lang="scss" scoped>
@keyframes slideInFromBottom {
  0% {
    transform: translateY(100%);
    opacity: 0;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

;

.data-error-enter-active {
  animation: slideInFromBottom 0.5s;
}

;

.data-error-leave-active {
  animation: slideInFromBottom 0.5s reverse;
}

;

.toast {
  &-wrapper {
    box-shadow: var(--elevation-2);
    margin: var(--gutter-m) var(--gutter-5xl);
    border-radius: var(--gutter-xs);
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    text-align: center;
    z-index: 1000;
  }

  &-content {
    padding: var(--gutter-m);
    color: white;

    &.success {
      background-color: var(--color-green-50);
    }

    &.error {
      background-color: var(--color-red-50);
    }
  }
}
</style>